// extracted by mini-css-extract-plugin
export default {"numberButtons":"calculatorNumberButtons_numberButtons__krU-n","zeroButton":"calculatorNumberButtons_zeroButton__aCUXF","numberButton":"calculatorNumberButtons_numberButton__aJl5z"};